<template></template>
<script>
  import moment from 'moment-timezone';

  export default {
    mounted() {
      window.Laravel['timezone'] = moment.tz.guess();
      this.setClientTimezone();
    },
    methods: {
      setClientTimezone() {
        let clientTimezone = moment.tz.guess();
        axios
          .post(`/user/timezone`, { timezone: clientTimezone })
          .then(() => {})
          .catch(error => {
            alert(
              'An error occurred when setting the timezone. Application will fallback to UTC Timezone',
            );
            console.error(error);
          });
      },
    },
  };
</script>
